import React from 'react';
import { Grid, GridCol, GridRow } from '@naf/grid';
import { breakpoints } from '@naf/theme';
import { ImageCard } from '@naf-simba/sections-cards';
import styled from '@emotion/styled';

import { ImageLinksType } from '@appTypes/imageLinksType';
import { useDocumentUrlWithNode } from '@hooks/Documents/useDocumentUrl';
import { StyledLink } from '@components/styled-link/StyledLink';
import { LinkWithImageType } from '@appTypes/CategoryListWithScrollType';
import ResponsiveImage from '@components/image/ResponsiveImage';

type ImageLinksBlockProps = {
  block: ImageLinksType;
};

export const InternalLinkCard = ({ item: { link, image } }: { item: LinkWithImageType }) => {
  const linkImage = image || link.internalReference?.image;
  const imgId = linkImage?.public_id || linkImage?.publicId;

  const href = useDocumentUrlWithNode(link.internalReference);

  if (href) {
    return (
      <StyledLink to={href} $hasCardGrid>
        <ImageCard
          title={link.title}
          media={{ render: () => <ResponsiveImage imageId={imgId} altText={image?.altText || image?.alt} /> }}
          isInternalLink
        />
      </StyledLink>
    );
  }
  if (link.externalTarget?.href) {
    return (
      <ImageCard
        title={link.title}
        href={link.externalTarget.href}
        target={link?.externalTarget?.blank ? '_blank' : '_self'}
        media={{ render: () => <ResponsiveImage imageId={imgId} altText={image?.altText || image?.alt} /> }}
      />
    );
  }
  return null;
};

export const ImageLinks = ({ imageLinks }: { imageLinks: LinkWithImageType[] }) => {
  const GridColumn = imageLinks?.length > 1 ? GridCol : StyledGridCol;
  if (imageLinks?.length === 0) {
    return null;
  }
  return (
    <Grid className="ImageLinksBlock">
      <GridRow>
        {imageLinks.map((item) => (
          <GridColumn s="12" m="6" l="6" xl="6" key={item._key || item.key}>
            <InternalLinkCard item={item} />
          </GridColumn>
        ))}
      </GridRow>
    </Grid>
  );
};

export const ImageLinksBlock = ({ block }: ImageLinksBlockProps) => <ImageLinks imageLinks={block.imageLinks} />;

export const StyledGridCol = styled(GridCol)`
  grid-column-start: 4;
  @media (max-width: ${breakpoints.s}) {
    grid-column-start: 1;
  }
`;
